import { Skelton } from 'library/skelton';

const ProgressGPTBarSuggestionLoading = () => {
    return (
        <div className="flex  items-center justify-center gap-3 mt-6 w-full">
            {Array.from(Array(3).keys()).map((r, i) => (
                <Skelton key={r} width="100%" className="text-sm px-4 py-2" />
            ))}
        </div>
    );
};

export default ProgressGPTBarSuggestionLoading;
